<ng-container matColumnDef="checkboxes">
  <th mat-header-cell *matHeaderCellDef class="checkboxes-header">
    <mat-checkbox
      *ngIf="!hideCheckboxInHeader"
      class="me-4 easy-checkbox"
      (change)="$event ? dataSource.toggleAllRows() : null"
      [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
      [indeterminate]="
        dataSource.selection.hasValue() && !dataSource.isAllSelected()
      "
    >
    </mat-checkbox>
  </th>
  <td mat-cell *matCellDef="let row" class="checkboxes-column">
    <mat-checkbox
      class="me-4 easy-checkbox"
      (click)="$event.stopPropagation()"
      (change)="$event ? dataSource.selection.toggle(row) : null"
      [checked]="dataSource.selection.isSelected(row)"
    >
    </mat-checkbox>
  </td>
</ng-container>
